import * as main from "../sass/main.sass";
import * as react_highlight_vs2019_custom from "../react-highlight-vs2019-custom.css";
import { Program_withReactBatched } from "./fable_modules/Fable.Elmish.HMR.6.0.0-beta-002/../Fable.Elmish.React.4.0.0-beta-1/react.fs.js";
import { ProgramModule_mkSimple } from "./fable_modules/Fable.Elmish.4.0.0-beta-3/program.fs.js";
import { AppView, update, init } from "./App.fs.js";
import { createElement } from "react";
import { ProgramModule_runWith } from "./fable_modules/Fable.Elmish.HMR.6.0.0-beta-002/../Fable.Elmish.4.0.0-beta-3/program.fs.js";
import { RouterModule_urlSegments } from "./fable_modules/Feliz.Router.3.8.0/./Router.fs.js";



window["process"]={
    cwd: () => "",
};

(function () {
    const program_2 = Program_withReactBatched("feliz-app", ProgramModule_mkSimple(init, update, (model, dispatch) => createElement(AppView, {
        model: model,
        dispatch: dispatch,
    })));
    ProgramModule_runWith(RouterModule_urlSegments(window.location.hash, 1), program_2);
})();

